import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/loader/mask.png'
import _imports_1 from '@/assets/images/loader/arche.png'


const _withScopeId = n => (_pushScopeId("data-v-43501197"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "LoadingFrontLayer view-default" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "LoadingFrontLayer__mask",
    src: _imports_0,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "LoadingFrontLayer__arche" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_1,
      alt: ""
    })
  ])
], -1))
const _hoisted_2 = { class: "Loading__Background" }
const _hoisted_3 = { class: "Loading__Inner view-default__inner" }
const _hoisted_4 = { class: "Loading__Claim font-regular uppercase" }
const _hoisted_5 = { class: "Loading__Progress font-regular" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "Loading__PortalMask" }, [
  /*#__PURE__*/_createElementVNode("svg", { viewBox: "0 0 298 413" }, [
    /*#__PURE__*/_createElementVNode("defs", null, [
      /*#__PURE__*/_createElementVNode("clipPath", {
        transform: "scale(0.003355704698, 0.002421307506)",
        id: "portalMask",
        clipPathUnits: "objectBoundingBox"
      }, [
        /*#__PURE__*/_createElementVNode("path", {
          fill: "#000",
          d: "M297 412H1V149C1 67.26 67.26 1 149 1s148 66.26 148 148v263Z"
        })
      ])
    ])
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inset_border = _resolveComponent("inset-border")!
  const _component_PortalLoader = _resolveComponent("PortalLoader")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", {
      class: "Loading view-default bg-white",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClick && _ctx.onClick(...args)))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_inset_border)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_PortalLoader, { class: "Loading__Portal" }, {
          default: _withCtx(() => [
            _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t('loading.claim')), 1)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("span", null, _toDisplayString(_ctx.$t('loading.label')), 1)
      ]),
      _hoisted_6
    ])
  ], 64))
}